// import React from "react";
// import { findObjectUseCase } from "../../../usecases";
// import EmployeeId from "../../../components/EmployeeId";
// import printComponent from "../../../printComponent";
// import employee from "../../../employee.json";
// import { useNavigate } from "react-router-dom";

// function EmployeePage() {
//   // const [employee, setEmployee] = React.useState([]);
//   const [objects, setObjects] = React.useState([]); // Assuming objects is an array in your state
//   const [object, setObject] = React.useState([]);
//   const [prints, setPrints] = React.useState([]);
//   const rePrintRef = React.useRef();
//   const navigate = useNavigate();

//   const find = findObjectUseCase();

//   console.log("employee", employee);

//   const setStatePromise = (index) => {
//     return new Promise((resolve) => {
//       setPrints(index);
//       resolve();
//     });
//   };

//   const onPrint = (index) => {
//     const selectedObject = employee[index];
//     setStatePromise(selectedObject)
//       .then(() => printComponent(rePrintRef.current, "residents"))
//       .then((result) => {
//         console.log("result", result);
//       })
//       .catch((error) => {
//         alert(error);
//       });
//   };

//   const onView = (index) => {
//     const selectedEmployee = employee[index];
//     navigate(`/card/${selectedEmployee.id}`);
//   };

//   return (
//     <>
//       <div className="d-none-2">
//         <div ref={rePrintRef}>
//           <EmployeeId employees={prints} o={object} />
//         </div>
//       </div>
//       <div className="overflow-auto">
//         <div className="p-3 p-lg-4">
//           <div className="d-flex justify-content-between align-items-center">
//             {" "}
//             <h1 className="fw-bold mt-3 mb-4 text-capitalize">Employees</h1>
//           </div>
//           <table class="table table-striped">
//             <thead className="">
//               <tr style={{ backgroundColor: "red", color: "white" }}>
//                 <th
//                   className="fs-xs align-middle text-nowrap text-uppercase"
//                   style={{ backgroundColor: "black", color: "white" }}
//                 >
//                   FIRST NAME
//                 </th>
//                 <th
//                   className="fs-xs align-middle text-nowrap text-uppercase"
//                   style={{ backgroundColor: "black", color: "white" }}
//                 >
//                   MIDDLE NAME
//                 </th>
//                 <th
//                   className="fs-xs align-middle text-nowrap text-uppercase"
//                   style={{ backgroundColor: "black", color: "white" }}
//                 >
//                   LAST NAME
//                 </th>
//                 <th
//                   className="fs-xs align-middle text-nowrap text-uppercase"
//                   style={{ backgroundColor: "black", color: "white" }}
//                 >
//                   POSITION
//                 </th>
//                 <th
//                   className="fs-xs align-middle text-nowrap text-uppercase"
//                   style={{ backgroundColor: "black", color: "white" }}
//                 >
//                   ACTIONS
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {employee.map((e, index) => {
//                 return (
//                   <tr>
//                     <td className="fs-sm text-truncate">{e.firstName}</td>
//                     <td className="fs-sm text-truncate">{e.middleName}</td>
//                     <td className="fs-sm text-truncate">{e.lastName}</td>
//                     <td className="fs-sm text-truncate">{e.position}</td>

//                     <td className="fs-sm text-truncate">
//                       <button
//                         className="btn btn-primary btn-sm fs-xs shadow-none me-2"
//                         onClick={() => onNFC(index)}
//                       >
//                         NFC
//                       </button>
//                       <button
//                         className="btn btn-primary btn-sm fs-xs shadow-none me-2"
//                         onClick={() => onView(index)}
//                       >
//                         View
//                       </button>
//                       <button
//                         className="btn btn-primary btn-sm fs-xs shadow-none"
//                         onClick={() => onPrint(index)}
//                       >
//                         Print
//                       </button>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </>
//   );
// }

// export default EmployeePage;

import React from "react";
import { findObjectUseCase } from "../../../usecases";
import EmployeeId from "../../../components/EmployeeId";
import printComponent from "../../../printComponent";
import employee from "../../../employee.json";
import { useNavigate } from "react-router-dom";
// Make sure the path is correct
import { Modal, Button } from "react-bootstrap"; // or use your own modal component
import NFCWriter from "../../nfc/NFCWriter";

function EmployeePage() {
  const [objects, setObjects] = React.useState([]);
  const [object, setObject] = React.useState([]);
  const [prints, setPrints] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [selectedEmployee, setSelectedEmployee] = React.useState(null);

  const rePrintRef = React.useRef();
  const navigate = useNavigate();
  const find = findObjectUseCase();

  const setStatePromise = (index) => {
    return new Promise((resolve) => {
      setPrints(index);
      resolve();
    });
  };

  const onPrint = (index) => {
    const selectedObject = employee[index];
    setStatePromise(selectedObject)
      .then(() => printComponent(rePrintRef.current, "residents"))
      .then((result) => {
        console.log("result", result);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const onView = (index) => {
    const selectedEmployee = employee[index];
    navigate(`/card/${selectedEmployee.id}`);
  };

  const onNFC = (index) => {
    setSelectedEmployee(employee[index]);
    setShowModal(true);
  };

  return (
    <>
      <div className="d-none-2">
        <div ref={rePrintRef}>
          <EmployeeId employees={prints} o={object} />
        </div>
      </div>
      <div className="overflow-auto">
        <div className="p-3 p-lg-4">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="fw-bold mt-3 mb-4 text-capitalize">Employees</h1>
          </div>
          <table className="table table-striped">
            <thead>
              <tr style={{ backgroundColor: "red", color: "white" }}>
                {[
                  "FIRST NAME",
                  "MIDDLE NAME",
                  "LAST NAME",
                  "POSITION",
                  "ACTIONS",
                ].map((title) => (
                  <th
                    key={title}
                    className="fs-xs align-middle text-nowrap text-uppercase"
                    style={{ backgroundColor: "black", color: "white" }}
                  >
                    {title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {employee.map((e, index) => (
                <tr key={index}>
                  <td className="fs-sm text-truncate">{e.firstName}</td>
                  <td className="fs-sm text-truncate">{e.middleName}</td>
                  <td className="fs-sm text-truncate">{e.lastName}</td>
                  <td className="fs-sm text-truncate">{e.position}</td>
                  <td className="fs-sm text-truncate">
                    <button
                      className="btn btn-primary btn-sm fs-xs shadow-none me-2"
                      onClick={() => onNFC(index)}
                    >
                      NFC
                    </button>
                    <button
                      className="btn btn-primary btn-sm fs-xs shadow-none me-2"
                      onClick={() => onView(index)}
                    >
                      View
                    </button>
                    <button
                      className="btn btn-primary btn-sm fs-xs shadow-none"
                      onClick={() => onPrint(index)}
                    >
                      Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* NFC Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Write to NFC Tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEmployee && (
            <NFCWriter url={`https://mweeb.com/card/${selectedEmployee.id}`} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EmployeePage;
